import { createSelector } from '@reduxjs/toolkit';

import type { IGrade } from '@/Module/Grade/Model/DataModel';
import { gradeSelectAll } from '@/Module/Grade/Store/Selector';
import type { IState } from '@/Module/Store/Model';

const findGrade = (grades: IGrade[], gradeId: IGrade['id']): IGrade | undefined => {
  for (const grade of grades) {
    if (grade.id === gradeId) {
      return grade;
    }

    if (grade.children?.length) {
      const find = findGrade(grade?.children, gradeId);
      if (find) return find;
    }
  }

  return undefined;
};

export const findGradeSelector = createSelector(
  [gradeSelectAll, (_state, gradeId: IGrade['id'] | null) => gradeId],
  (grades, gradeId) => {
    if (!gradeId) return undefined;
    return findGrade(grades, gradeId);
  },
);

export const selectedGradeSelector = createSelector(
  [gradeSelectAll, (state: IState) => state.grade.selectedGradeId],
  (grades, gradeId) => {
    if (!gradeId) return undefined;
    return findGrade(grades, gradeId);
  },
);
